import(/* webpackMode: "eager", webpackExports: ["RegisterPageView"] */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/components/apply/RegisterPageView.tsx");
